import React from 'react';
import Badge, { BadgeProps } from 'shared/components/vxl/Badge/Badge';
import Icon, { IconProps } from 'shared/components/vxl/icon/Icon/Icon';
import Switch, {
  SwitchProps,
} from 'shared/components/vxl/selection/Switch/Switch';
import { Tag, TagProps } from 'shared/components/vxl/Tag/Tag';
import { VXLComponent, VXLComponentId } from 'shared/renderer/types';
import theme from 'shared/styles/theme';
import { Maybe } from 'shared/utils/types';

import ListItemTextStack, {
  ListItemTextStackAlignment,
  ListItemTextStackProps,
} from './ListItemTextStack';

export interface ListItemTrailingAccessoryProps extends VXLComponent {
  name:
    | VXLComponentId.BADGE
    | VXLComponentId.ICON
    | VXLComponentId.LIST_ITEM_TEXT_STACK
    | VXLComponentId.SWITCH
    | VXLComponentId.TAG;
  props:
    | BadgeProps
    | ListItemTextStackProps
    | IconProps
    | SwitchProps
    | TagProps;
}

const ListItemTrailingAccessory = ({
  accessory,
  isDisabled,
}: {
  accessory: ListItemTrailingAccessoryProps;
  isDisabled: boolean;
}) => {
  const { name, props } = accessory;
  let content: Maybe<React.ReactNode> = null;
  if (name === VXLComponentId.BADGE) {
    // Badge labelText is not supported in ListItem
    content = <Badge {...(props as BadgeProps)} labelText={undefined} />;
  } else if (name === VXLComponentId.LIST_ITEM_TEXT_STACK) {
    content = (
      <ListItemTextStack
        textAlignment={ListItemTextStackAlignment.TRAILING}
        {...(props as ListItemTextStackProps)}
        isDisabled={isDisabled}
      />
    );
  } else if (name === VXLComponentId.ICON) {
    content = (
      <Icon
        {...(props as IconProps)}
        iconSize="MD"
        iconColor={
          isDisabled
            ? theme.color.text.muted
            : ((props as IconProps).iconColor ?? theme.color.text.primary)
        }
      />
    );
  } else if (name === VXLComponentId.SWITCH) {
    content = <Switch isDisabled={isDisabled} {...(props as SwitchProps)} />;
  } else if (name === VXLComponentId.TAG) {
    content = <Tag {...(props as TagProps)} />;
  }

  return content;
};

export default ListItemTrailingAccessory;
